/**
 * Bereichsfarben — deterministische, rein clientseitige Farbzuordnung je Bereich.
 *
 * unternehmen.jsonc's Bereiche[] hat kein Farbfeld (die Bereichsfarben im Design-Handoff sind feste
 * Design-Tokens, keine vom Kunden konfigurierbaren Daten), daher wird die Farbe hier aus der
 * BereichID abgeleitet statt gespeichert. Sortierung nach _id (nicht nach Name oder Anzeige-
 * Reihenfolge) hält die Zuordnung stabil, unabhängig davon, in welcher Reihenfolge/Filterung ein
 * Bereich gerade angezeigt wird — ein Bereich bekommt immer dieselbe Farbe.
 */

const PALETTE = [
	'#2a6fdb', // service blue (Design-Handoff Default --c-service)
	'#b8791a', // kueche amber (Design-Handoff Default --c-kueche)
	'#7a5af0', // bar violet (Design-Handoff Default --c-bar)
	'#1f8a5b',
	'#c0485a',
	'#0f8a94',
	'#a85c1f',
	'#5b6df0',
];

let cache = null;
let cacheKey = null;

/**
 * Berechnet (und cached) die Farbzuordnung für eine Liste von Bereichen.
 * @param {array<object>} bereiche unternehmen.Bereiche (jedes Element braucht mindestens _id)
 * @returns {Map<string,string>} BereichID -> Hex-Farbe
 */
function berechneBereichFarben(bereiche) {
	const ids = (bereiche || []).map((b) => b._id).sort();
	const key = ids.join(',');
	if (cache && cacheKey === key) {
		return cache;
	}
	const map = new Map();
	ids.forEach((id, index) => {
		map.set(id, PALETTE[index % PALETTE.length]);
	});
	cache = map;
	cacheKey = key;
	return map;
}

/**
 * @param {array<object>} bereiche unternehmen.Bereiche
 * @param {string} bereichID
 * @returns {string} Hex-Farbe, Fallback auf die erste Palettenfarbe falls nicht gefunden
 */
function farbeFuerBereich(bereiche, bereichID) {
	const map = berechneBereichFarben(bereiche);
	return map.get(bereichID) || PALETTE[0];
}

export { berechneBereichFarben, farbeFuerBereich };
